import React, { useEffect, useState, useRef } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Input, Button, UncontrolledDropdown, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Auth } from "aws-amplify";
import * as nanoid from "nanoid";
import { filesize } from "filesize";
import IntlMessages from "../../helpers/IntlMessages";
import { templateGetItem, addCommentItem } from "../../redux/request/actions";

const SaySomething = ({ templateMessages, templateGetItem, placeholder, request, staffId, addCommentItem, settings }) => {
  const [dropdownBasicOpen, setDropdownBasicOpen] = useState(false);
  const [dropDownValue, setDropDownValue] = useState("all");
  const [dropDownValueAdd, setDropDownValueAdd] = useState(true);
  const [inputValue, setInputValue] = useState();
  const ref = useRef(null);
  const templateLanguages = templateMessages ? templateMessages.language : undefined;
  const [selectedFile, setSelectedFile] = useState();
  const [preview, setPreview] = useState();
  const sendButtonRef = useRef(null);

  const addAllValue = () => {
    if (templateLanguages && !Object.keys(templateLanguages).all) {
      templateLanguages.all = [];
    }
  };

  const getExtension = filename => {
    return filename
      .split(".")
      .slice(-1)
      .pop();
  };

  const isImage = filename => {
    const imageExtensions = ["gif", "jpg", "png", "jpeg"];
    return imageExtensions.includes(getExtension(filename));
  };

  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    if (isImage(selectedFile.name)) {
      const objectUrl = URL.createObjectURL(selectedFile);
      setPreview(objectUrl);
    }
  }, [selectedFile]);

  const onSelectFile = () => {
    if (ref.current && ref.current.files && ref.current.files[0]) {
      setSelectedFile(ref.current.files[0]);
      return;
    }
    setSelectedFile(undefined);
  };

  useEffect(() => {
    templateGetItem();
    if (templateLanguages && Object.keys(templateLanguages).length > 0) {
      setDropDownValue(templateLanguages.English ? "English" : templateLanguages.Turkish ? "Turkish" : Object.keys(templateLanguages)[0]);
      setDropDownValueAdd(true);
    }
    addAllValue();
    if (sendButtonRef && sendButtonRef.current) {
      sendButtonRef.current.scrollIntoView(false);
    }
    Auth.currentAuthenticatedUser().then(authData => { });
  }, []);

  const toggleBasic = () => {
    addAllValue();
    setDropdownBasicOpen(dropdownBasicOpen => !dropdownBasicOpen);
  };

  const changeDropDownValueAdd = item => {
    setDropDownValueAdd(true);
    setDropDownValue(item);
  };

  const SendButtonClick = buttonMessageInput => {
    setInputValue(buttonMessageInput);
  };

  const handleChatInputChange = message => {
    setInputValue(message);
  };

  const handleSendButtonClick = () => {
    setInputValue("");
    if (selectedFile) {
      const extension = getExtension(selectedFile.name);
      const id = nanoid(10);
      const newFile = `${request.hotel_id}/${request.id}/${id}.${extension}`;
      var attachments = [
        {
          content_type: selectedFile.type,
          content_url: newFile,
          id,
          name: selectedFile.name,
          bytes: selectedFile.size
        }
      ];
      addCommentItem({
        hotel_id: request.hotel_id,
        request_id: request.id,
        author_id: staffId,
        body: inputValue,
        attachments,
        file: selectedFile,
        id
      });
      setSelectedFile(undefined);
    } else {
      addCommentItem({
        request_id: request.id,
        author_id: staffId,
        body: inputValue
      });
    }
  };

  const handleCancelAttachment = () => {
    setSelectedFile(undefined);
  };

  return (
    <div>
      <div className="chat-input-container d-flex justify-content-between align-items-center">
        <i className="iconsminds-pen" style={{ fontSize: "15px", paddingLeft: "10px" }} />
        <Input
          className="form-control-message-box flex-grow-1"
          type="textarea"
          rows="2"
          placeholder={placeholder}
          value={inputValue}
          onChange={e => handleChatInputChange(e.target.value)}
          style={{ resize: "none", paddingTop: "32px", fontStyle: "italic", fontSize: "15px" }}
        />
        <div className="justify-content-between d-flex align-items-center">
          {selectedFile ? (
            <div className="preview-container d-flex zero-clipboard justify-content-between">
              <link onClick={handleCancelAttachment} className="btn-clipboard iconsminds-close" />
              {preview ? (
                <img src={preview} className="preview-container" alt="preview" />
              ) : (
                <div align="center" style={{ width: "140px", height: "80px" }}>
                  {selectedFile.name} <br /> {filesize(selectedFile.size, { base: 2, standard: "jedec" })}
                </div>
              )}
            </div>
          ) : (
            <div className="btn btn-default btn-file btn-success">
              <input ref={ref} type="file" onChange={onSelectFile} className="" />
              <IntlMessages id="request.upload" /> <i className="simple-icon-paper-clip" />
            </div>
          )}
          <Button disabled={request.is_staff === "true"} color="primary" className="large ml-1" onClick={() => handleSendButtonClick()}>
            <IntlMessages id="request.message_send_button" /> <i className="simple-icon-arrow-right" />
          </Button>
          <div ref={sendButtonRef} />
        </div>
      </div>

      {templateLanguages && (
        <div className="template-send-group mt-3 d-flex mb-5">
          <>
            <div>
              <UncontrolledDropdown className="ml-2">
                <Dropdown isOpen={dropdownBasicOpen} toggle={toggleBasic} className="ml-2">
                  <DropdownToggle caret color="light" className="language-button w-xs-100 px-5" style={{ width: "150px" }}>
                    <span className="name">
                      {dropDownValue === "all" ? (settings.locale === "en" ? "All" : "Hepsi") : dropDownValue.toUpperCase()}
                    </span>
                  </DropdownToggle>
                  <DropdownMenu>
                    {Object.keys(templateLanguages).map((item, index) => (
                      <DropdownItem key={index} onClick={() => changeDropDownValueAdd(item)}>
                        {item === "all" ? (settings.locale === "en" ? "All" : "Hepsi") : item.toUpperCase()}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </UncontrolledDropdown>
            </div>
            <div className="ml-2">
              {dropDownValueAdd &&
                dropDownValue &&
                dropDownValue !== "all" &&
                templateLanguages[dropDownValue].map((item, index) => (
                  <Button key={index} data-toggle="tooltip" title={item.title} className="template-button" onClick={() => SendButtonClick(item.text)}>
                    {item.title}
                  </Button>
                ))}
              {dropDownValueAdd &&
                dropDownValue &&
                dropDownValue === "all" &&
                Object.keys(templateLanguages).map(langs =>
                  templateLanguages[langs].map((item, index) => (
                    <Button key={index} data-toggle="tooltip" title={item.title} className="template-button" onClick={() => SendButtonClick(item.text)}>
                      {item.title}
                    </Button>
                  ))
                )}
            </div>
          </>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ requestApp, settings }) => {
  const { templateMessages } = requestApp;
  return { settings, templateMessages };
};

const mapActionsToProps = {
  addCommentItem,
  templateGetItem
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(SaySomething)
);
